import { convertToChatNovelScript } from '~/app/(default-layout)/s/[storyId]/_utils/chat-script-converter';
import type {
  QueryRequest,
  QueryResponse,
} from '~/app/_repositories/query-types';
import type { ChatNovelScript } from '~/app/_types/chat-script';
import { convertIErrorResponseToAppError } from '~/infra/api/error-handler';
import { AppError } from '~/models/app-error';
import { ErrorType } from '~/models/app-error';

export const buildRequest = (storyId: string): QueryRequest => {
  const requestId = `FETCH_STORY_CHAT_NOVEL_SCRIPT-${storyId}`;
  return {
    request_list: [
      {
        request_id: requestId,
        story_request: {
          id: storyId,
          require_story: {
            require_chat_novel_script: {
              require_script_image_list: {
                require_id: true,
                require_serving_url: true,
                require_width: true,
                require_height: true,
              },
              require_full_script: true,
              require_trial_script: true,
            },
          },
        },
      },
    ],
  };
};

export const convertResponseToChatNovelScript = (
  response: QueryResponse,
  isTrial: boolean
): ChatNovelScript => {
  const error = response?.response_list[0]?.error;

  if (error) {
    throw convertIErrorResponseToAppError(error);
  }

  const storyResponse = response?.response_list[0]?.story;

  if (!storyResponse || !storyResponse.chat_novel_script) {
    throw new AppError(ErrorType.API_REQUEST_404, 'non public', 404, undefined);
  }

  const tellerScript = isTrial
    ? storyResponse.chat_novel_script.trial_script
    : storyResponse.chat_novel_script.full_script ||
      // フォロワー限定はfull_scriptがないのでtrial_scriptを使う
      storyResponse.chat_novel_script.trial_script;

  if (tellerScript === undefined) {
    throw new AppError(ErrorType.API_REQUEST_404, 'non public', 404, undefined);
  }

  const imageResourcesList =
    storyResponse.chat_novel_script.script_image_list ?? [];
  const chatNovelScript = convertToChatNovelScript(
    tellerScript,
    imageResourcesList
  );

  return chatNovelScript;
};
